<template>
  <div>
    <b-modal v-model="modalVisible" id="modal-login" centered ref="contatoModal" title="Contato"
      :ok-title="type === 'adicionar' ? 'Adicionar' : 'Atualizar'" :ok-disabled="type === 'visualizar' || !formIsValid"
      cancel-variant="outline-secondary" cancel-title="Cancelar" @hidden="resetModal" @ok="handleOk">
      <validation-observer ref="contatoForm" v-slot="{ valid }" slim>
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="sequencial">SEQUENCIAL</label>
                <b-form-input id="sequencial" type="text" placeholder="Sequencial" v-model="contato.clientecontatoseq"
                  :disabled="type === 'visualizar' || type === 'atualizar' || type === 'adicionar'" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="area">ÁREA</label>
                <b-form-input id="area" type="text" placeholder="Área" v-model="contato.clientearea"
                  :disabled="type === 'visualizar'" />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group>
                <label for="nome">NOME</label>
                <validation-provider name="Nome" rules="required|alpha" v-slot="{ errors }">
                  <b-form-input id="nome" type="text" placeholder="Nome" v-model="contato.clientecontatonome"
                    :disabled="type === 'visualizar'" :state="errors.length > 0 ? false : null" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <label for="email">E-MAIL</label>
                <validation-provider name="E-mail" rules="required|email" v-slot="{ errors }">
                  <b-form-input id="email" type="text" placeholder="E-mail" v-model="contato.clientecontatoemail"
                    :disabled="type === 'visualizar'" :state="errors.length > 0 ? false : null" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label for="telefone">TELEFONE</label>
                <validation-provider name="Telefone" :rules="contato.clientecontatocelular ? '' : 'required'"
                  v-slot="{ errors }">
                  <b-form-input id="telefone" type="text" placeholder="Telefone"
                    v-mask="['(##) #####-####', '(##) ####-####']" v-model="contato.clientecontatotelefone"
                    :disabled="type === 'visualizar'" :state="errors.length > 0 ? false : null" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ramal">RAMAL</label>
                <b-form-input id="ramal" type="text" placeholder="Ramal" v-model="contato.clientecontatoramal"
                  :disabled="type === 'visualizar'" />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label for="celular">CELULAR</label>
                <validation-provider name="Celular" :rules="contato.clientecontatotelefone ? '' : 'required'"
                  v-slot="{ errors }">
                  <b-form-input id="celular" type="text" placeholder="Celular" v-model="contato.clientecontatocelular"
                    v-mask="['(##) #####-####', '(##) ####-####']" :disabled="type === 'visualizar'"
                    :state="errors.length > 0 ? false : null" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <label for="contatoPrincipal">CONTATO PRINCIPAL</label>
              <b-form-group>
                <b-form-checkbox id="contatoPrincipal" name="contatoPrincipal" switch inline
                  v-model="contato.clientecontatoprincipal" :disabled="type === 'visualizar'" />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <label for="observacoes">OBSERVAÇÕES</label>
                <b-form-input id="observacoes" type="text" placeholder="Observações"
                  v-model="contato.clientecontatoobservacoes" :disabled="type === 'visualizar'" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';
import PTC_CadastroClienteService from '@/services/PTC/PTC_CadastroCliente.service';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, email, alpha, numeric,
} from '@validations';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { mapGetters } from 'vuex';

const ptc_cadastroClienteService = new PTC_CadastroClienteService();

export default {
  components: {
    BFormSelect,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      modalVisible: false,
      type: '',
      isProcessing: false,
      formIsValid: false,
      toastShown: false,
      contato: {
        clientecontatoseq: '',
        clientearea: '',
        clientecontatonome: '',
        clientecontatoseqerp: '',
        clientecontatoemail: '',
        clientecontatotelefone: '',
        clientecontatoramal: '',
        clientecontatocelular: '',
        clientecontatoprincipal: false,
        clientecontatoobservacoes: '',
      },
    };
  },
  methods: {
    abrirModal(tipoOperacao, dados = null) {
      this.type = tipoOperacao;
      this.isProcessing = false;

      if (tipoOperacao === 'atualizar' || tipoOperacao === 'visualizar') {
        this.contato = { ...dados };
        if (tipoOperacao === 'visualizar') {
          this.formIsValid = true;
        } else {
          this.$nextTick(() => {
            this.checkFormValidity();
          });
        }
      } else {
        this.contato = {
          clientecontatoseq: '13113',
          clientearea: '',
          clientecontatonome: '',
          clientecontatoseqerp: 1,
          clientecontatoemail: '',
          clientecontatotelefone: '',
          clientecontatoramal: '',
          clientecontatocelular: '',
          clientecontatoprincipal: false,
          clientecontatoobservacoes: '',
        };
        this.$nextTick(() => {
          this.checkFormValidity();
        });
      }

      this.modalVisible = true;
    },
    async checkFormValidity() {
      if (this.type === 'visualizar') {
        this.formIsValid = true;
        return;
      }

      if (this.$refs.contatoForm) {
        const isValid = await this.$refs.contatoForm.validate();
        this.formIsValid = isValid;
      }
    },
    resetModal() {
      this.contato = {
        clientecontatoseq: '13113',
        clientearea: '',
        clientecontatonome: '',
        clientecontatoseqerp: 1,
        clientecontatoemail: '',
        clientecontatoramal: '',
        clientecontatocelular: '',
        clientecontatoprincipal: false,
        clientecontatoobservacoes: '',
      };
      this.formIsValid = false;
      this.isProcessing = false;
      this.toastShown = false;

      this.$nextTick(() => {
        if (this.$refs.contatoForm) {
          this.$refs.contatoForm.reset();
        }
      });
    },
    handleOk(bvModalEvt) {
      if (this.isProcessing) {
        bvModalEvt.preventDefault();
        return;
      }

      bvModalEvt.preventDefault();
      this.validateForm();
    },
    async validateForm() {
      if (this.isProcessing) {
        return;
      }

      const isValid = await this.$refs.contatoForm.validate();
      this.formIsValid = isValid;

      if (!isValid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro de validação',
            text: 'Por favor, preencha todos os campos obrigatórios.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
        return;
      }

      this.handleSubmit();
    },
    async handleSubmit() {
      if (this.isProcessing || this.toastShown) {
        return;
      }

      this.isProcessing = true;
      this.toastShown = false;

      try {
        if (this.type === 'adicionar') {
          await this.createContato();
        }
        if (this.type === 'atualizar') {
          await this.updateContato();
        }

        await ptc_cadastroClienteService.RetornaContatos();

        if (!this.toastShown) {
          this.toastShown = true;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: this.type === 'adicionar' ? 'Contato adicionado com sucesso!' : 'Contato atualizado com sucesso!',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          });
        }

        this.modalVisible = false;
      } catch (error) {
        console.error('Erro ao processar contato:', error);

        if (!this.toastShown) {
          this.toastShown = true;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro',
              text: 'Ocorreu um erro ao processar o contato.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }
      } finally {
        this.isProcessing = false;
        setTimeout(() => {
          this.toastShown = false;
        }, 1000);
      }
    },
    async createContato() {
      await ptc_cadastroClienteService.CreateContato(this.contato);
    },
    async updateContato() {
      await ptc_cadastroClienteService.UpdateContato(this.contato);
    },
  },
  watch: {
    contato: {
      deep: true,
      handler() {
        if (this.isProcessing) {
          return;
        }

        this.$nextTick(() => {
          this.checkFormValidity();
        });
      },
    },
    type(val) {
      if (val === 'visualizar') {
        this.formIsValid = true;
      }
    },
  },
};
</script>
